import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: 'button.component.html',
  styleUrls: ['button.component.scss'],
})
export class ButtonComponent {
  @Input()
  type: 'button' | 'submit' | 'reset' | 'menu' = 'button';

  @Input()
  buttonType: 'primary' | 'normal' | 'danger' | 'dark' = 'normal';

  @Input()
  styleType: 'contained' | 'outlined' | 'text' = 'contained';

  @Input()
  shapeType: 'rounded' | 'circle' | 'square' = 'rounded';

  @Input()
  sizeType: 'x-small' | 'small' | 'normal' | 'large' | 'x-large' = 'normal';

  @Input()
  marginType: 'normal' | 'icon' = 'normal';

  @Input()
  text: string;

  @Input()
  icon: string;

  @Input()
  @HostBinding('style.--btn-width')
  width: string;

  @Input()
  @HostBinding('style.--btn-height')
  height: string;

  @Input()
  disabled = false;

  @HostBinding('class')
  get hostClass() {
    return [
      `button-type-${this.buttonType}`,
      `button-shape-${this.shapeType}`,
      `button-style-${this.styleType ?? 'contained'}`,
      `size-${this.sizeType ?? 'normal'}`,
      `button-margin-type-${this.marginType}`,
      this.disabled ? 'state-disabled' : '',
      this.text ? 'button-has-text' : '',
      this.icon ? 'button-has-icon' : '',
    ]
      .filter((x) => !!x)
      .join(' ');
  }
}
